import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { useSelectedNetworkImportTypes } from "../../hooks/useSelectedNetworkImportType";
import { Button } from "../../UI/Button";
import { MappingFormModal } from "../MappingFormModal";

export const CreateMappingButton = () => {
  const { setIsOpen } = useModalContext();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { isKinetic } = useSelectedNetworkImportTypes();

  const handleClick = () => setIsOpen(true);

  return (
    <>
      <Button appearance="primary" isDisabled={!selectedNetworkId} onClick={handleClick}>
        Create Mapping
      </Button>
      <MappingFormModal isKinetic={isKinetic} />
    </>
  );
};
